"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESKTOP_MIN = exports.TABLET_MAX = exports.TABLET_MIN = exports.MOBILE_MAX = exports.TOP_NAV_HEIGHT = exports.ASIDE_PANEL_COLLAPSED_WIDTH = exports.ASIDE_PANEL_FULL_WIDTH = exports.ASIDE_NAV_WIDTH = exports.CONTAINER = exports.BOUNDARY = void 0;
var calc_space_1 = require("../scale/calc-space");
exports.BOUNDARY = 1440;
exports.CONTAINER = exports.BOUNDARY / 16;
exports.ASIDE_NAV_WIDTH = (0, calc_space_1.calcSpace)(10);
exports.ASIDE_PANEL_FULL_WIDTH = (0, calc_space_1.calcSpace)(50);
exports.ASIDE_PANEL_COLLAPSED_WIDTH = (0, calc_space_1.calcSpace)(8);
exports.TOP_NAV_HEIGHT = (0, calc_space_1.calcSpace)(8);
exports.MOBILE_MAX = '560px';
exports.TABLET_MIN = '561px';
exports.TABLET_MAX = '1024px';
exports.DESKTOP_MIN = '1025px';
//# sourceMappingURL=index.js.map